export interface PropertyListing {
  id: string;
  slug: string;
  title: string;
  description: string;
  fullDescription: string[];
  type: 'satilik' | 'kiralik';
  category: 'daire' | 'villa' | 'arsa' | 'isyeri' | 'dukkan' | 'ofis';
  price: number;
  currency: string;
  ilce: string;
  ilceSlug: string;
  mahalle: string;
  mahalleSlug: string;
  address: string;
  roomCount?: string;
  netArea: number;
  grossArea: number;
  buildingAge: string;
  floor: string;
  totalFloors?: number;
  heating: string;
  balcony: boolean;
  site: boolean;
  siteName?: string;
  featured?: boolean;
  /** İmar durumu (arsa ve ticari mülkler) */
  zoning?: string;
  /** Tapu durumu (arsa ve ticari mülkler) */
  deedStatus?: string;
  /** Ada / parsel bilgisi (arsa) */
  parcelInfo?: string;
  kaks?: string;
  gabari?: string;
  /** Kullanım durumu: boş, kiracılı vb. (ticari mülkler) */
  occupancy?: string;
  images: string[];
  features: string[];
  agent: {
    name: string;
    whatsapp: string;
    title: string;
    image?: string;
  };
  createdAt: string;
  status?: 'published' | 'draft' | 'archived';
  updatedAt?: string;
  seoTitle?: string;
  seoDescription?: string;
}

export const LISTINGS: PropertyListing[] = [
  {
    id: "1542",
    slug: "gurselpasa-3-1-satilik-luks-daire-1542",
    title: "Gürselpaşa Mahallesi Site İçi 3+1 Geniş Lüks Satılık Daire",
    description: "Adana Seyhan Gürselpaşa Aliya İzzetbegoviç Bulvarı yakınlarında, ebeveyn banyolu, çift balkonlu 3+1 lüks daire.",
    fullDescription: [
      "Corner Gayrimenkul güvencesiyle Adana Seyhan Gürselpaşa Mahallesi'nin en prestijli konumunda yer alan 3+1 satılık dairemiz yeni sahibini bekliyor.",
      "Aliya İzzetbegoviç Bulvarı'na yürüme mesafesinde bulunan dairemiz; geniş peyzaj alanına sahip, 7/24 özel güvenlikli ve açık yüzme havuzlu nezih bir site içerisindedir.",
      "Dairemizde ebeveyn banyosu, geniş cam balkon kapamalı ana balkon, ankastre mutfak seti, birinci sınıf laminat parke ve giyinme odası alanı bulunmaktadır. Tüm odalar ferah ve bol ışık almaktadır.",
      "Okullara, süpermarketlere, otobüs duraklarına ve pazara oldukça yakın lokasyondadır. Hem oturum hem yatırım amaçlı yüksek prim potansiyeline sahiptir."
    ],
    type: "satilik",
    category: "daire",
    price: 3450000,
    currency: "TL",
    ilce: "Seyhan",
    ilceSlug: "seyhan",
    mahalle: "Gürselpaşa",
    mahalleSlug: "gurselpasa",
    address: "Gürselpaşa Mah. Aliya İzzetbegoviç Bulv. Seyhan / Adana",
    roomCount: "3+1",
    netArea: 165,
    grossArea: 185,
    buildingAge: "0-3 Yaş",
    floor: "6. Kat",
    totalFloors: 12,
    heating: "Merkezi (Pay Ölçer)",
    balcony: true,
    site: true,
    siteName: "Corner Park Konutları",
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1000&q=80"
    ],
    features: [
      "Ebeveyn Banyosu",
      "Açık Yüzme Havuzu",
      "Çift Asansör",
      "7/24 Güvenlik ve Kamera",
      "Açık & Kapalı Otopark",
      "Çocuk Oyun Alanı",
      "Jeneratör",
      "Ankastre Mutfak",
      "Vestiyer",
      "Cam Balkon"
    ],
    agent: {
      name: "Gürkan Sönmez",
      whatsapp: "905335487801",
      title: "Gayrimenkul Danışmanı & Kurucu",
    },
    createdAt: "2026-08-01"
  },
  {
    id: "1632",
    slug: "guzelyali-golu-manzarali-4-1-satilik-villa-1632",
    title: "Çukurova Güzelyalı Göle Sıfır Panoramik Manzaralı 4+1 Müstakil Villa",
    description: "Adana Çukurova Güzelyalı Mahallesi'nde Seyhan Baraj Gölü manzaralı, müstakil havuzlu lüks villa.",
    fullDescription: [
      "Çukurova Güzelyalı Mahallesi'nin eşsiz lokasyonunda, Seyhan Baraj Gölü panoramik manzarasına sahip özel müstakil villamız satışa sunulmuştur.",
      "Toplam 550 m² arsa üzerinde 380 m² net kullanım alanına sahip olan villamızda özel açık yüzme havuzu, geniş peyzajlı bahçe ve 2 araçlık özel kapalı garaj bulunmaktadır.",
      "Yüksek tavanlı salon, şömine, akıllı ev otomasyon sistemi, sauna, ebeveyn suit odası ve geniş teras alanıyla lüks yaşam standartlarını yeniden tanımlamaktadır."
    ],
    type: "satilik",
    category: "villa",
    price: 18500000,
    currency: "TL",
    ilce: "Çukurova",
    ilceSlug: "cukurova",
    mahalle: "Güzelyalı",
    mahalleSlug: "guzelyali",
    address: "Güzelyalı Mah. Süleyman Demirel Bulvarı Yakını, Çukurova / Adana",
    roomCount: "4+1",
    netArea: 380,
    grossArea: 450,
    buildingAge: "0-2 Yaş",
    floor: "Müstakil (3 Katlı)",
    heating: "Klima & Yerden Isıtma",
    balcony: true,
    site: false,
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1000&q=80"
    ],
    features: [
      "Panoramik Gölü Manzarası",
      "Özel Yüzme Havuzu",
      "Akıllı Ev Sistemi",
      "Müstakil Bahçe",
      "Kapalı Garaj",
      "Yerden Isıtma",
      "Şömine",
      "Sauna",
      "Güvenlik Kameraları"
    ],
    agent: {
      name: "Gürkan Sönmez",
      whatsapp: "905335487801",
      title: "Gayrimenkul Danışmanı & Kurucu",
    },
    createdAt: "2026-08-03"
  },
  {
    id: "1558",
    slug: "pinar-mahallesi-site-ici-4-1-satilik-daire-1558",
    title: "Seyhan Pınar Mahallesi Site İçi 4+1 Lüks Satılık Daire",
    description: "Seyhan Pınar Mahallesi otoban bağlantısına yakın, site içi, geniş balkona sahip 4+1 daire.",
    fullDescription: [
      "Adana Seyhan Pınar Mahallesi'nde gelişen altyapısı ve merkezi lokasyonuyla dikkat çeken 4+1 geniş satılık daire.",
      "Çift ebeveyn banyosu, geniş çocuk oyun odası alanı ve 20 m² geniş balkona sahiptir. Otoban çıkışına 2 dakika mesafededir."
    ],
    type: "satilik",
    category: "daire",
    price: 4200000,
    currency: "TL",
    ilce: "Seyhan",
    ilceSlug: "seyhan",
    mahalle: "Pınar",
    mahalleSlug: "pinar",
    address: "Pınar Mah. 74001 Sok. Seyhan / Adana",
    roomCount: "4+1",
    netArea: 190,
    grossArea: 215,
    buildingAge: "4-5 Yaş",
    floor: "8. Kat",
    totalFloors: 14,
    heating: "Kombi (Doğalgaz)",
    balcony: true,
    site: true,
    siteName: "Pınar Prestij Rezidans",
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1000&q=80"
    ],
    features: [
      "Çift Ebeveyn Banyosu",
      "Doğalgaz Kombi",
      "Site İçi Açık Otopark",
      "Çocuk Parkı",
      "7/24 Güvenlik",
      "Spor Salonu"
    ],
    agent: {
      name: "Gürkan Sönmez",
      whatsapp: "905335487801",
      title: "Gayrimenkul Danışmanı & Kurucu",
    },
    createdAt: "2026-08-04"
  },
  {
    id: "1602",
    slug: "cukurova-mahfesigmaz-3-1-kiralik-daire-1602",
    title: "Çukurova Mahfesığmaz Turgut Özal Bulvarı Yakını 3+1 Kiralık Daire",
    description: "Adana Çukurova Mahfesığmaz Mahallesi Turgut Özal Bulvarı arkasında bakımlı, 3+1 ferah kiralık daire.",
    fullDescription: [
      "Turgut Özal Bulvarı'na 100 metre mesafede yer alan kiralık 3+1 dairemiz yeni boyanmış, taşınmaya hazır durumdadır.",
      "Ulaşım ağlarına, cafe ve restoranlara yürüme mesafesindedir. Aileye uygun nezih binadır."
    ],
    type: "kiralik",
    category: "daire",
    price: 24000,
    currency: "TL",
    ilce: "Çukurova",
    ilceSlug: "cukurova",
    mahalle: "Mahfesığmaz",
    mahalleSlug: "mahfesigmaz",
    address: "Mahfesığmaz Mah. Turgut Özal Bulvarı Paraleli, Çukurova / Adana",
    roomCount: "3+1",
    netArea: 145,
    grossArea: 160,
    buildingAge: "6-10 Yaş",
    floor: "4. Kat",
    totalFloors: 9,
    heating: "Kombi (Doğalgaz)",
    balcony: true,
    site: false,
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1000&q=80"
    ],
    features: [
      "Turgut Özal Bulvarı Yakını",
      "Doğalgazlı",
      "Asansör",
      "Çift Balkon",
      "Açık Otopark"
    ],
    agent: {
      name: "Gürkan Sönmez",
      whatsapp: "905335487801",
      title: "Gayrimenkul Danışmanı & Kurucu",
    },
    createdAt: "2026-08-05"
  },
  {
    id: "1645",
    slug: "gurselpasa-2-1-esyali-kiralik-daire-1645",
    title: "Gürselpaşa Mahallesi Lüks Eşyalı 2+1 Kiralık Daire",
    description: "Seyhan Gürselpaşa'da sıfır ayarında mobilyalı, klimalı ve beyaz eşyalı 2+1 kiralık daire.",
    fullDescription: [
      "Gürselpaşa Mahallesi'nde yer alan 2+1 eşyalı dairemiz tüm ev eşyaları tam ve eksiksiz olarak kiralanacaktır.",
      "Klima, TV, buzdolabı, çamaşır makinesi, bulaşık makinesi, koltuk takımı ve yatak odası mobilyaları mevcuttur."
    ],
    type: "kiralik",
    category: "daire",
    price: 22000,
    currency: "TL",
    ilce: "Seyhan",
    ilceSlug: "seyhan",
    mahalle: "Gürselpaşa",
    mahalleSlug: "gurselpasa",
    address: "Gürselpaşa Mah. 75. Yıl Bulvarı Yakını, Seyhan / Adana",
    roomCount: "2+1",
    netArea: 105,
    grossArea: 120,
    buildingAge: "0-2 Yaş",
    floor: "3. Kat",
    totalFloors: 10,
    heating: "Kombi & Klima",
    balcony: true,
    site: true,
    siteName: "Gürselpaşa Modern Sitesi",
    featured: false,
    images: [
      "https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1000&q=80"
    ],
    features: [
      "Tam Eşyalı",
      "İki Adet Klima",
      "Modern Mutfak",
      "Asansör",
      "Güvenlik Kamera Sistemi"
    ],
    agent: {
      name: "Gürkan Sönmez",
      whatsapp: "905335487801",
      title: "Gayrimenkul Danışmanı & Kurucu",
    },
    createdAt: "2026-08-06"
  },
  {
    id: "1670",
    slug: "saricam-yatirimlik-konut-imarsi-arsa-1670",
    title: "Sarıçam Çarkıpare Mahallesi Satılık Konut İmarlı Arsa 500 m²",
    description: "Adana Sarıçam Çarkıpare'de üniversite ve yeni stadyum yakınında yatırımlık konut imarlı arsa.",
    fullDescription: [
      "Adana Sarıçam gelişme bölgesinde Çukurova Üniversitesi ve Yeni Adana Stadyumu'na yakın lokasyonda 500 m² köşe parsel arsa.",
      "1.5 emsal konut imarlı, altyapısı hazır, yol ve elektrik sorunu olmayan yüksek yatırım değerli parsel."
    ],
    type: "satilik",
    category: "arsa",
    price: 3100000,
    currency: "TL",
    ilce: "Sarıçam",
    ilceSlug: "saricam",
    mahalle: "Çarkıpare",
    mahalleSlug: "carkipare",
    address: "Çarkıpare Mah. Stadyum Yolu Üzeri, Sarıçam / Adana",
    netArea: 500,
    grossArea: 500,
    buildingAge: "Arsa",
    floor: "Arsa",
    heating: "Yok",
    balcony: false,
    site: false,
    featured: false,
    images: [
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1000&q=80"
    ],
    features: [
      "1.5 Emsal Konut İmarlı",
      "Köşe Parsel",
      "Altyapı Tam",
      "Yol ve Su Mevcut",
      "Üniversiteye Yakın"
    ],
    agent: {
      name: "Gürkan Sönmez",
      whatsapp: "905335487801",
      title: "Gayrimenkul Danışmanı & Kurucu",
    },
    createdAt: "2026-08-07"
  }
];
